import './suggest.less';
import PropTypes from 'prop-types';
import React from 'react';
import ClickOutside from 'react-onclickoutside';
import Checkbox from '../form-elements/checkbox';

const propTypes = {
	langs: PropTypes.array,
	onToggleLanguage: PropTypes.func,
	onClickOutside: PropTypes.func
};

class Suggest extends React.Component {
	handleClickOutside() {
		this.props.onClickOutside();
	}

	render() {
		return (
			<div className="lang-dropdown">
				{ this.props.langs.map(lang => (
					<div className="lang-dropdown__item" key={lang.id}>
						<label htmlFor={lang.id}>
							<Checkbox
								input={{
									name: lang.id,
									value: lang.isSelected,
									onChange: () => this.props.onToggleLanguage(lang.id)
								}}/>
							<span className={`item-flag flag-icon flag-icon-${lang.id}`} />
							<span className="item-title">{lang.text}</span>
						</label>
					</div>
				)) }
			</div>
		);
	}
}

Suggest.propTypes = propTypes;

export default ClickOutside(Suggest);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/lang/suggest.js